export default __webpack_public_path__ + "static/media/tele.69023918.glb";